import { $authHost } from ".";

class BasketApi {
  async getEvrimaBasket(signal) {
    const { data } = await $authHost.get("/evrima/shop/basket", {
      signal,
    });
    return data;
  }

  async deleteEvrimaBasketId(shopItemId, amount, signal) {
    const { data } = await $authHost.delete(`/evrima/shop/basket`, {
      params: {
        shopItemId,
        amount,
      },
      signal,
    });
    return data;
  }

  async addEvrimaBasketId(shopItemId, amount, signal) {
    const { data } = await $authHost.put(
      `/evrima/shop/basket`,
      {
        shopItemId,
        amount,
      },
      {
        signal,
      }
    );
    return data;
  }

  async buyItem(shopItemId, serverId, amount, signal) {
    const { data } = await $authHost.post(
      `/evrima/shop/buy`,
      {
        shopItemId,
        serverId,
        amount,
      },
      {
        signal,
      }
    );
    return data;
  }
}

const basketApi = new BasketApi();
export default basketApi;
